<template>
  <module-configuration :data="config" :errors="errors" @save="refreshStatusOrder">
    <div slot="auth" class="l-row">
      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>
      <form-group label="Email">
        <input class="form-input" type="email" v-model="config.auth.email">
      </form-group>
      <form-group label="Token">
        <input class="form-input" v-model="config.auth.token">
      </form-group>
    </div>
    <panel title="Produtos">
      <div class="l-row">
        <product-price-configuration :input="config.product.price"/>
        <form-group label="Redutor de estoque padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.reducer">
        </form-group>
        <form-group label="Formato de envio das categorias">
          <select v-model="config.category.format" class="form-select">
            <option value="name">{{ $t('name.label') }}</option>
            <option value="fullNameHierarch">{{ $t('fullNameHierarch.label') }}</option>
          </select>
          <small class="form-help">Define como serão enviadas as categorias dos produtos.</small>
        </form-group>
      </div>
      <div class="l-row">
        <form-group label="Envio de gênero nas categorias">
          <label class="form-switch">
            <input type="checkbox" v-model="config.category.gender">
            <span class="form-switch__indicator"></span>
          </label>
          <small class="form-help">Adiciona o gênero do produto na raiz da árvore de categorias enviadas para o marketplace.</small>
        </form-group>
        <form-group label="Envio de faixa etária nas categorias">
          <label class="form-switch">
            <input type="checkbox" v-model="config.category.ageGroup">
            <span class="form-switch__indicator"></span>
          </label>
          <small class="form-help">Adiciona a faixa etária do produto na raiz da árvore de categorias enviadas para o marketplace.</small>
        </form-group>
        <form-group label="Utilizar um produto por variação">
          <label class="form-switch">
            <input type="checkbox" v-model="config.product.singleVariation">
            <span class="form-switch__indicator"></span>
          </label>
          <small class="form-help">Transforma cada variação do produto em um produto individual no marketplace.</small>
        </form-group>
      </div>
      <form-group label="Enviar informação de prazo extra">
        <label class="form-switch">
          <input type="checkbox" v-model="config.product.forwardCrossDocking">
          <span class="form-switch__indicator"></span>
        </label>
        <small class="form-help">Define se a informação de prazo extra dos produtos será sincronizada com o marketplace.</small>
      </form-group>
    </panel>
    <panel :title="$t('expediter.label')">
      <expediter-configuration :expediter="config.order.expediter"/>
    </panel>
    <panel title="Status de pedidos">
      <div slot="header-right">
          <a href="#" @click="refreshStatusOrder()" class="btn btn--info"><i class="icon-spinner11"></i></a>
      </div>
      <loader :loading="fetching"/>
      <div class="l-row" v-if="statuses.length">
        <form-group :label="$t('invoiced.label')">
          <select v-model="config.order.forward.status.APPROVED" class="form-select">
            <option value="null">Selecione</option>
            <option v-for="status in statuses" :key="status.code" :value="status.code">{{ status.label }}</option>
          </select>
          <small class="form-help">Status que será enviado ao informar os dados da etapa de faturamento.</small>
        </form-group>
        <form-group :label="$t('shipped.label')">
          <select v-model="config.order.forward.status.SHIPPED" class="form-select">
            <option value="null">Selecione</option>
            <option v-for="status in statuses" :key="status.code" :value="status.code">{{ status.label }}</option>
          </select>
          <small class="form-help">Status que será enviado ao informar os dados da etapa de transporte.</small>
        </form-group>
        <form-group :label="$t('delivered.label')">
          <select v-model="config.order.forward.status.DELIVERED" class="form-select">
            <option value="null">Selecione</option>
            <option v-for="status in statuses" :key="status.code" :value="status.code">{{ status.label }}</option>
          </select>
          <small class="form-help">Status que será enviado ao informar os dados da etapa de entrega.</small>
        </form-group>
      </div>
      <div v-else-if="!fetching" class="u-bolder u-textCenter t-error">Não foi possível buscar os status dos pedidos da Skyhub.</div>
    </panel>

    <panel :title="$t('quotation.label')">
      <div class="l-row">
        <div class="l-col-6@md">
          <quotation-configuration :quotation="config.quotation" :marketplace="identifier"/>
        </div>
      </div>
    </panel>

    <panel :title="$t('order.label')">
      <order-retrieve-date-configuration :orderConfigs="config.order"/>
    </panel>

    <panel title="Sincronização">
      <div class="l-row">

        <form-group label="Sincronizar estoque" :columns="3">
          <select class="form-select" v-model="config.synchronize.stock">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os estoques serão sincronizados e atualizados na Skyhub.</small>
        </form-group>

        <form-group label="Sincronizar preço" :columns="3">
          <select class="form-select" v-model="config.synchronize.price">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os preços serão sincronizados e atualizados na Skyhub.</small>
        </form-group>

        <form-group label="Sincronizar pedidos fullfilment" :columns="3">
          <select class="form-select" v-model="config.synchronize.fullfilment">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se pedidos que possuem fullfilment serão integrados</small>
        </form-group>

      </div>
    </panel>

  </module-configuration>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import ExpediterConfiguration from '@/components/marketplace/shared/ExpediterConfiguration'
  import QuotationConfiguration from '@/components/marketplace/shared/QuotationConfiguration'
  import OrderRetrieveDateConfiguration from '@/components/marketplace/shared/OrderRetrieveDateConfiguration'

  export default {
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'skyhub'
      }
    },
    inject: ['expeditersDI', 'priceTypeDI', 'quotationDI'],
    data: () => ({
      errors: [],
      type: 'marketplace',
      identifier: 'skyhub',
      config: {
        auth: {
          environment: 'sandbox',
          email: null,
          token: null
        },
        product: {
          forwardCrossDocking: false,
          price: {
            type: null,
            percent: null
          },
          stock: {
            reducer: 0
          },
          singleVariation: false
        },
        category: {
          gender: false,
          format: 'name',
          ageGroup: false
        },
        order: {
          expediter: {
            type: null,
            identifier: null
          },
          forward: {
            status: {
              APPROVED: null,
              SHIPPED: null,
              DELIVERED: null
            }
          },
          retrieveDate: null
        },
        quotation: {
          shipmentMethod: null
        },
        synchronize: {
          stock: true,
          price: true,
          fullfilment: true
        }
      },
      priceType: null,
      format: null,
      gender: null,
      ecommerce: null,
      fetching: true,
      synchronizeOptions: [
        true,
        false
      ]
    }),
    async mounted () {
      if (!this.statuses.length) {
        await this.fetch({
          type: this.type,
          identifier: this.identifier
        })
      }
      this.fetching = false
    },
    methods: {
      ...mapActions('orderStatuses', [
        'fetch'
      ]),
      async refreshStatusOrder () {
        this.fetching = true
        await this.fetch({
          type: this.type,
          identifier: this.identifier
        })
        this.fetching = false
      }
    },
    watch: {
      'config.product.stock.reducer' (value) {
        this.config.product.stock.reducer = parseInt(value)
      }
    },
    computed: {
      ...mapGetters('module', [
        'definitionEcommerceInstalled'
      ]),
      ...mapGetters('orderStatuses', [
        'findByModuleTypeAndIdentifier'
      ]),
      dataSources () {
        return this.definitionEcommerceInstalled
      },
      statuses () {
        return this.findByModuleTypeAndIdentifier(this.type, this.identifier)
      }
    },
    components: {
      OrderRetrieveDateConfiguration,
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader,
      ProductPriceConfiguration,
      ExpediterConfiguration,
      QuotationConfiguration
    }
  }
</script>



// WEBPACK FOOTER //
// Skyhub.vue?fcdd53d6